export const usesPermissionSet = account =>
  account?.role !== 'administrator' &&
  (account?.permission_set_id != null ||
    account?.permission_source === 'permission_set');
